import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';

import {
    Box, Divider, Typography, Grid, Button, Container, Fab, FormControl, TextField, Autocomplete,
    Paper
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

function NuevaCotizacion() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [cliente, setCliente] = useState('');
    const [fechaDeCotizacion, setFechaDeCotizacion] = useState(DateTime.now());
    const [descrpicion, setDescripcion] = useState('');

    const [disabled, setDisabled] = useState(false);

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    const [clientes, setClientes] = useState([
        { id: 1, nombre: 'Cliente 1' },
        { id: 2, nombre: 'Cliente 2' },
        { id: 3, nombre: 'Cliente 3' },
        { id: 4, nombre: 'Cliente 4' },
        { id: 5, nombre: 'Cliente 5' },
    ]);

    useEffect(() => {
        if (!['Admin', 'Vendedor', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Nueva Cotización';
    }, [auth])

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            const res = await axios.get('/api/clients/');
            if (res.status === 200) {
                setClientes(res.data);
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisabled(true);

        const tyc = [
            {
                uuid: 'e881b63c-e563-44c2-b2e8-a120fbc579c6',
                key: 'Condiciones de pago: ',
                value: 'El 100% del pago debe realizarse por adelantado.',
            },
            {
                uuid: 'bdd98880-5c1e-4e52-8c43-fc792cd857c3',
                key: 'Tiempo de entrega: ',
                value: '8 días hábiles a partir de la confirmación del pago.',
            },
            {
                uuid: '08f3c0e8-cb34-4c6a-a1f5-1fdbce6ab8a1',
                key: 'Vigencia de la cotización: ',
                value: '5 días desde la fecha de emisión.',
            },
            {
                uuid: 'fc11f7fd-ded7-4fc7-a9bd-63f25a575acf',
                key: 'Garantía: ',
                value: '30 días hábiles por defectos de fabricación.',
            },
            {
                uuid: '029bb377-7252-4a7c-82c1-b51608ae0809',
                key: 'Forma de pago: ',
                value: 'Transferencia electrónica o depósito bancario.',
            },
            {
                uuid: 'f8902044-9185-4262-86ee-45634d161272',
                key: 'Envío: ',
                value: 'No incluido, salvo que se indique lo contrario en la cotización.',
            },
            {
                uuid: 'c2a48f76-339d-4d7b-9c80-639c51a94efe',
                key: 'Precios: ',
                value: 'Sujetos a cambios sin previo aviso.',
            },
            {
                uuid: '6ec578af-2756-43ef-b605-6824ddc321c3',
                key: 'Revisión de productos: ',
                value: 'Verifique las características de los productos antes de efectuar el pago, una vez realizado, no hay cambios ni devoluciones.',
            },
        ]

        const order = {
            cliente: cliente,
            estatus: 'Pendiente',
            fechaDeCotizacion: fechaDeCotizacion,
            descripcion: descrpicion,
            vendedor: auth.user.name,
            formatoCotizacion: {
                encabezado: [],
                datos: [],
                pie: tyc
            }
        };

        try {
            const res = await axios.post('/api/orders/', { order: order });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Se creo la cotización', severity: 'success' } });
                setTimeout(() => {
                    navigate('/cotizaciones');
                }, 800);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear el documento, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                <Container maxWidth='xl'>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Nueva Cotización</Typography>
                    </Box>

                    <Button size='small' variant='outlined' onClick={() => navigate('/cotizaciones')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Datos de la cotización' className='text-bold' />
                    </Divider>

                    <form onSubmit={(e) => handleSubmit(e)}>
                        <Fab aria-label="add" type='submit' color='success' disabled={disabled} style={{ position: 'fixed', top: '60px', left: '12px', zIndex: '10', opacity: '60%' }}>
                            <i className="fad fa-save fa-2x"></i>
                        </Fab>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={8}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setCliente(newInputValue)}
                                        inputValue={cliente}
                                        aria-multiline='true'
                                        options={clientes.map((option) => `${option.name} ▸ ${option.contact}`)}
                                        renderInput={(params) => <TextField {...params} label='Cliente' />}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6} lg={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Cotización"
                                        format="dd/MM/yyyy"
                                        value={fechaDeCotizacion}
                                        onChange={(newValue) => setFechaDeCotizacion(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Descripción" variant="outlined" value={descrpicion} onChange={(e) => setDescripcion(e.target.value)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <hr></hr>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Button variant="contained" color="success" type='submit' disabled={disabled}>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}

export default NuevaCotizacion;